import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Cruise, Flights, Hotel, Rental, Wishlist } from '../../assests/ExportImageIcon'
import service from '../../services/service'
import endpoints from '../../services/endpoints'
import './wishlist.css'

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const FolderIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
        <path d="M3 6.5C3 5.67 3.67 5 4.5 5h4.19c.33 0 .65.13.88.37L10.8 6.6c.23.24.55.37.88.37H19.5c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-15C3.67 19 3 18.33 3 17.5v-11Z" fill="#0A0A0A" />
    </svg>
)

const TrashIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M2 4h12M5.5 4V2.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V4m-7 0 .7 8.4a1 1 0 0 0 1 .9h4.6a1 1 0 0 0 1-.9L12.5 4"
            stroke="#E7000B"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const TYPE_ICONS = {
    flight: Flights,
    hotel: Hotel,
    car: Rental,
    cruise: Cruise,
}

const typeIcon = (recordModule) => {
    const key = String(recordModule || '').toLowerCase().replace(/s$/, '')
    return TYPE_ICONS[key] || Wishlist
}

const AddWishlistItem = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const wishlistId = location.state?.wishlistId
    const shareLink = location.state?.shareLink
    const [selectedItems, setSelectedItems] = useState(location.state?.selectedItems || [])
    const [submitting, setSubmitting] = useState(false)

    const goToShareStep = () => {
        navigate('/wishlist-setting', { state: { wishlistId, shareLink } })
    }

    const handleBrowse = () => {
        navigate('/select-items', { state: { wishlistId, selectedItems, shareLink } })
    }

    const removeItem = (id) => {
        setSelectedItems((prev) => prev.filter((item) => item.id !== id))
    }

    const handleFinish = async () => {
        if (submitting) return
        if (!selectedItems.length) {
            goToShareStep()
            return
        }
        setSubmitting(true)
        try {
            await service.post(
                endpoints.wishlists.itemsCreate.replace('{wishlist_id}', wishlistId),
                selectedItems.map((item) => ({
                    provider: 'self',
                    record_module: item.record_module,
                    record_id: item.record_id,
                    record_name: item.record_name,
                    product_id: item.product_id,
                    image_url: item.image_url,
                })),
                { silent: true },
            )
            goToShareStep()
        } catch {
            // error toast already shown by the service interceptor
        } finally {
            setSubmitting(false)
        }
    }

    if (!wishlistId) {
        return (
            <section className='allSearchArea commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <p className='fare-extra-hint'>No wishlist in progress. Please start from Create Wishlist.</p>
                    <button type='button' className='commonBtn' onClick={() => navigate('/create-wishlist')}>Create Wishlist</button>
                </div>
            </section>
        )
    }

    return (
        <section className='allSearchArea commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='commonMaxWidth'>
                            <div className='tripDocHeader mb-4' onClick={() => navigate(-1)}>
                                <BackArrow />
                                <span className='bsSectionTitle'>Add Items</span>
                            </div>
                            <div className='mb-4'>
                                <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <div className='createWishlistStep__top'>
                                        <span>Add Items</span>
                                        <span>2/5</span>
                                    </div>
                                    <div className='createWishlistStep__track'>
                                        <div className='createWishlistStep__fill' style={{ width: '40%' }} />
                                    </div>
                                </div>
                            </div>

                            {!selectedItems.length ? (
                                <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <div className='wishlistEmptyState'>
                                        <div className='wishlistEmptyState__rings'>
                                            <span className='wishlistEmptyState__ring wishlistEmptyState__ring--1' />
                                            <span className='wishlistEmptyState__ring wishlistEmptyState__ring--2' />
                                            <span className='wishlistEmptyState__ring wishlistEmptyState__ring--3' />
                                            <span className='wishlistEmptyState__icon'>
                                                <FolderIcon />
                                            </span>
                                        </div>
                                        <div className='wishlistEmptyState__title'>No Items Yet</div>
                                        <p className='wishlistEmptyState__desc'>
                                            Add items from your Wishlist or search for new hotels, flights, and activities to include in this trip.
                                        </p>
                                        <button type='button' className='commonBtn wishlistEmptyState__btn' onClick={handleBrowse}>Browse</button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                                        <div className='selectItemsCount'>
                                            <span className='selectItemsCount__label'>
                                                {selectedItems.length} {selectedItems.length === 1 ? 'Item' : 'Items'} selected
                                            </span>
                                            <button type='button' className='tripSecureLink' onClick={handleBrowse}>Add more</button>
                                        </div>

                                        <div className='wishlistPage__list'>
                                            {selectedItems.map((item) => (
                                                <div className='wishlistCard commonBorder borderRadius20' key={item.id}>
                                                    <div className='wishlistCard__media'>
                                                        {item.image_url ? <img src={item.image_url} alt={item.record_name} /> : null}
                                                        <div className='wishlistCard__mediaBadges'>
                                                            <span className='wishlistCard__typeBadge'>
                                                                <img src={typeIcon(item.record_module)} alt="" />
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='wishlistCard__info'>
                                                        <div className='hotelCard__name'>{item.record_name || 'Saved item'}</div>
                                                    </div>

                                                    <button
                                                        type='button'
                                                        className='wishlistCard__removeBtn'
                                                        onClick={() => removeItem(item.id)}
                                                        aria-label="Remove item"
                                                        title="Remove item"
                                                    >
                                                        <TrashIcon />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <button type='button' className='commonBtn w-100 mt-4' onClick={handleFinish} disabled={submitting}>
                                        {submitting ? 'Adding...' : 'Add to Wishlist'}
                                    </button>
                                </>
                            )}

                            {!selectedItems.length && (
                                <button type='button' className='commonBtnTransparent w-100 mt-4' onClick={goToShareStep}>
                                    Skip for now
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddWishlistItem
